module.exports = __webpack_public_path__ + "static/media/CompetitorMain.90e2d1ce.docx";